import { McpConnectorActionStatusEnum } from "@ryde/shared";

/** sessionStorage mirror of the action id: survives login redirects that drop the hash query. */
export const MCP_CONNECTOR_ACTION_ID_KEY = "mcpConnectorActionId";

/** Indentation of the request body in the technical details. */
export const MCP_CONNECTOR_ACTION_DETAILS_JSON_INDENT = 2;

/** What the page says about an action that no longer waits for a decision. */
export const MCP_CONNECTOR_ACTION_STATUS_MESSAGE_KEYS: Readonly<
  Record<
    Exclude<McpConnectorActionStatusEnum, McpConnectorActionStatusEnum.Pending>,
    string
  >
> = {
  [McpConnectorActionStatusEnum.Approved]: "mcpConnectorAction.statusApproved",
  [McpConnectorActionStatusEnum.Denied]: "mcpConnectorAction.statusDenied",
  [McpConnectorActionStatusEnum.Expired]: "mcpConnectorAction.statusExpired",
  [McpConnectorActionStatusEnum.Running]: "mcpConnectorAction.statusRunning",
  [McpConnectorActionStatusEnum.Done]: "mcpConnectorAction.statusDone",
  [McpConnectorActionStatusEnum.Failed]: "mcpConnectorAction.statusFailed",
};
